import {
  AfterViewInit,
  Component,
  forwardRef,
  Input,
  OnInit,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TOGGLE } from '../../animations/toggle-animation';
@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true,
    },
  ],
  animations: [TOGGLE],
})
export class ToggleComponent
  implements OnInit, AfterViewInit, ControlValueAccessor
{
  @Input() formControlName: string;

  @Input() index: number = 0;

  @Input() startState: boolean = false;

  @Input() toggleWithText: boolean = false;

  onChange: any = () => {};

  onTouched: any = () => {};

  private _value: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit() {}

  public get value() {
    return this._value;
  }

  public set value(v) {
    this._value = v;
    this.onChange(this._value);
    this.onTouched();
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public toggleValue() {
    this.value = !this.value;

    setTimeout(() => {
      this.value ? this.setActiveBorder() : this.setInactiveBorder();
    }, 300);
  }

  public setActiveBorder() {
    document.getElementById(`toggle${this?.index}`).style.borderColor =
      '#3a3a3a';
  }

  public setInactiveBorder() {
    document.getElementById(`toggle${this.index}`).style.borderColor =
      '#b1b3be';
  }
}
